import { render } from "./RenewableEnergyTableComponent.vue?vue&type=template&id=6f6bf2c2"
import script from "./RenewableEnergyTableComponent.vue?vue&type=script&lang=js"
export * from "./RenewableEnergyTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__